import { SelectOption } from 'types/base';

export const resolveReceptionistLabel = (
  staffSelectOptions: SelectOption[],
  receptionistId?: number | null
): string => {
  if (receptionistId === null || receptionistId === undefined) return '';

  return (
    staffSelectOptions.find((option) => option.value === receptionistId)
      ?.label || `${receptionistId}`
  );
};
